<mat-form-field class="input-text" *ngIf="control && label">
  <mat-label> {{ label | translate }} </mat-label>
  <input [attr.aria-label]="label | translate" [disabled]="disabled" matInput [formControl]="control" [placeholder]="label | translate">
  <mat-error *ngIf="control.hasError('required')">
    {{ "REQUIRED_INPUT_ERROR" | translate }}
  </mat-error>
</mat-form-field>
